import React from 'react'
import { Box, Divider } from '@material-ui/core'
import { BuildingFragment } from '../../../generated/graphql'
import { BuildingParts } from './BuildingParts'
import { BuildingHourSeries } from './BuildingHourSeries'
import { BuildingTabCommonHeader } from '../BuildingTabCommonHeader'
import { BuildingCharts } from './BuildingCharts'

type Props = {
  building: BuildingFragment
}

export function BuildingBasicInfoTab({ building }: Props): React.ReactElement {
  return (
    <Box>
      <BuildingTabCommonHeader building={building} />

      <Divider />

      {building.parts.length > 0 && (
        <>
          <BuildingParts building={building} />

          <Divider />
        </>
      )}

      <BuildingCharts building={building} />

      <Divider />

      <BuildingHourSeries building={building} />
    </Box>
  )
}
